import { render, staticRenderFns } from "./importPanel.vue?vue&type=template&id=55593f5e&scoped=true&"
import script from "./importPanel.vue?vue&type=script&lang=js&"
export * from "./importPanel.vue?vue&type=script&lang=js&"
import style0 from "./importPanel.vue?vue&type=style&index=0&id=55593f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55593f5e",
  null
  
)

export default component.exports